import { render, staticRenderFns } from "./ProfileDialog.vue?vue&type=template&id=ed735cc2&scoped=true&"
import script from "./ProfileDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDialog.vue?vue&type=style&index=0&id=ed735cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed735cc2",
  null
  
)

export default component.exports